var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVip = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3D00",
  fillRule: "evenodd",
  d: "M11.25.5h-7.5L0 5.143 7.5 13.5 15 5.143 11.25.5ZM6.89 8.53 4.874 3.177l1.535-.002 1.128 3.96 1.175-3.96 1.413.002-2.02 5.35-1.215.001Z",
  clipRule: "evenodd"
})));
export default SvgVip;